export default filtered => {
    return {
        section_id: filtered.sections.map(section => section.value),
        period_id: filtered.periods.map(period => period.value),
        title: filtered.searchText,
        'user.name': filtered.name,
    }
}
